import { Link } from 'gatsby';
import React from 'react';
import { Dispatch, SetStateAction, useContext } from 'react';
import styled, { css, DefaultTheme, ThemeContext } from 'styled-components';
import { BlinkAnimationKeyframe } from '../styles/animation-blink';

const HeaderContainer = styled.header`
  display: flex;
  border: 2px double rgba(31, 248, 8, 0.9);
  box-shadow: 0px 0px 15px 5px rgba(31, 248, 8, 0.3),
    inset 0px 0px 15px 5px rgba(31, 248, 8, 0.3);
  height: 4rem;
  margin: 0.25rem;
  transition: all 0.5s ease-in-out;

  &:hover {
    box-shadow: 0px 0px 15px 5px rgba(31, 248, 8, 0.4),
      inset 0px 0px 15px 5px rgba(31, 248, 8, 0.4);
  }
`;

const HeaderLogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0.25rem;
  width: min-content;
`;

type HeaderLogoTextProps = {
  terminalCursor?: boolean;
};

const HeaderLogoText = styled.span<HeaderLogoTextProps>`
  color: ${({ theme }) =>
    theme.mode === 'dark'
      ? 'var(--dark-color-primary-transparent)'
      : 'var(--light-color-primary)'};
  text-shadow: 0px 0px 8px rgba(64, 248, 8, 0.7);
  font-family: 'VT323', monospace;
  font-weight: normal;
  font-size: 1.625rem;
  margin: 0;

  ${({ terminalCursor }) =>
    terminalCursor &&
    css`
      &::after {
        content: '_';
        animation: ${BlinkAnimationKeyframe} 1s infinite;
      }
    `}
`;

const HeaderLogoSeparator = styled.div`
  height: 100%;
  width: 2px;
  background: rgba(31, 248, 8, 0.9);
  box-shadow: 0px 0px 15px 5px rgba(31, 248, 8, 0.3),
    inset 0px 0px 15px 5px rgba(31, 248, 8, 0.3);
`;

type HeaderProps = {
  siteTitle: string;
  setTheme: Dispatch<SetStateAction<DefaultTheme>>;
};

const Header = ({ siteTitle }: HeaderProps) => {
  const theme = useContext(ThemeContext);

  return (
    <HeaderContainer>
      <Link to="/">
        <HeaderLogoContainer>
          <HeaderLogoText>Lukas</HeaderLogoText>
          <HeaderLogoText terminalCursor>Bobinas</HeaderLogoText>
        </HeaderLogoContainer>
      </Link>
      <HeaderLogoSeparator />
    </HeaderContainer>
  );
};

export default Header;
